/*=========================================================================================
  File Name: moduleMapMutations.js
  Description: Map Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	CLOSE_MAP_SIDEBAR(state) {
		state.toggleMapSidebar = false;
	},
	OPEN_MAP_SIDEBAR(state) {
		state.toggleMapSidebar = true;
	},
	TOGGLE_MAP_SIDEBAR(state, val) {
		state.toggleMapSidebar = val;
	},
	OPEN_STREETVIEW(state, val) {
		state.popupStreeViewActive = val;
	},
	SAVE_VISIT_POINT_MARKER(state, marker) {
		state.visitPointsMarkers = marker;
	},
	CLEAR_VISIT_POINT_MARKER(state) {
		state.visitPointsMarkers = [];
	},
	SAVE_VISIT_POINT_MARKER_DATARUTAS(state, marker) {
		state.visitPointsMarkersDatarutas = marker;
	},
	CLEAR_VISIT_POINT_MARKER_DATARUTAS(state) {
		state.visitPointsMarkersDatarutas = [];
	},
};
